// extracted by mini-css-extract-plugin
export var container = "styles-module--container--T3XQn";
export var line = "styles-module--line--iZvdq";
export var lineAnimation = "styles-module--line-animation--ATQGT";
export var arrowAnimation = "styles-module--arrow-animation--1WOIl";